import V2aAgreementViewer from 'features/v2a/sender/components/V2aAgreementViewer/V2aAgreementViewer';
import React from 'react';

export default function SenderAgreement() {
  return <V2aAgreementViewer />;
}
